import React from "react";
import { object, array, bool, number, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import LinkTag from "../../molecules/link-tag";
import CardImage from "../../atoms/cardimage";
import Headline from "../../atoms/headline";

import { getHeadline, getStoryLine } from "../../utils/utils";

import "./customStoryCard1.m.css";

const CustomStoryCard1 = ({
  story,
  aspectRatio,
  imageType,
  headerType,
  showAuthorName,
  showSummary,
  id,
  isExternalStory,
  pageType,
}) => {
  const headline = getHeadline(story);
  const storyLine = getStoryLine(story);

  return (
    <div className="custom-story-card-1">
      {pageType === "home-page" && storyLine ? storyLine !== "" && <div className="title">{storyLine}</div> : <></>}
      <div styleName="wrapper">
        <LinkTag href={story.url} isExternalStory={isExternalStory}>
          <CardImage
            story={story}
            aspectRatio={aspectRatio}
            imageType={imageType}
            widths={[700]}
            eager={true}
            showAuthorName={showAuthorName}
            showStoryTypeIcon
          />
        </LinkTag>

        <LinkTag href={story.url} isExternalStory={isExternalStory}>
          <Headline
            text={headline}
            headerType={headerType}
            headerLevel={1}
            story={story}
            width={20}
            height={20}
            id={id}
          />
        </LinkTag>

        {showSummary && story.summary && (
          <LinkTag href={story.url} styleName="summary-link" isExternalStory={isExternalStory}>
            <span styleName="summary" className="summary">
              {story.summary}
            </span>
          </LinkTag>
        )}
      </div>
    </div>
  );
};

CustomStoryCard1.defaultProps = {
  aspectRatio: [16, 9],
  imageType: "image16x9",
  headerType: 1,
  showAuthorName: false,
  showSummary: true,
  isExternalStory: false,
};

CustomStoryCard1.propTypes = {
  story: object.isRequired,
  aspectRatio: array,
  imageType: string,
  headerType: number,
  showAuthorName: bool,
  showSummary: bool,
  id: string,
  isExternalStory: bool,
  pageType: string,
};

const mapStateToProps = (state) => ({
  pageType: get(state, ["qt", "pageType"], null),
});

export default connect(mapStateToProps, null)(CustomStoryCard1);
